module.exports = __webpack_public_path__ + "img/options.1a6baf27.svg";